import { render, staticRenderFns } from "./WellElecControllRecordList.vue?vue&type=template&id=42e108e0"
import script from "./WellElecControllRecordList.vue?vue&type=script&lang=js"
export * from "./WellElecControllRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports